import find from 'lodash/find';
import isArray from 'lodash/isArray';


const findElement = (data, rel) => {
  let el = null
  el = find(data.data.included, rel);
  if (!el) el = find(data.data.data, rel);

  return el;
}
export const normalizeRelations = (data) => {
  if (!data.data.included && !data.data.data) return data;

  data.data.data.forEach((row) => {
    if (!row.relationships) return;
    Object.keys(row.relationships).forEach((key) => {
      const rel_row = row.relationships[key];
      if (!rel_row.data) return;
      if (isArray(rel_row.data)) {
        rel_row.data = rel_row.data.map((rel) => {
          const el = findElement(data, rel);

          return el ? { ...rel, ...el } : rel;
        });
      } else {
        const rel = rel_row.data;
        const el = findElement(data, rel);

        if (el) {
          rel_row.data = { ...rel, ...el };
        } else if (key === 'endorsement') {
          if (rel.id && !rel.attributes) {
            const endorsementFromData = find(data.data.data, (item) => item.id === rel.id);
            if (endorsementFromData) {
              rel_row.data = { ...rel, ...endorsementFromData };
            }
          }
        }
      }
    });
  });

  return data;
};


export default {};
